/* =============================================================
   GADGET CONNECTIONS :: main.js
   boot sequence + HUD clock + headline typing + glitch scramble
   ============================================================= */
(function () {
  'use strict';

  // ---------------------------------------------------------------
  // GAD-280 :: DevTools console banner
  // ---------------------------------------------------------------
  (function consoleBanner() {
    try {
      if (navigator && navigator.webdriver) return;
      const ua = ((navigator && navigator.userAgent) || '').toLowerCase();
      if (/bot|crawl|spider|slurp|googlebot|bingbot|duckduckbot|headless/.test(ua)) return;
      const banner = [
        '',
        ' ██████╗  ██████╗',
        '██╔════╝ ██╔════╝',
        '██║  ███╗██║     ',
        '██║   ██║██║     ',
        '╚██████╔╝╚██████╗',
        ' ╚═════╝  ╚═════╝',
        '',
        ' G A D G E T   C O N N E C T I O N S',
        ''
      ].join('\n');
      const green = 'color:#39ff14;font-family:monospace';
      const greenBold = green + ';font-weight:bold';
      console.log('%c' + banner, greenBold);
      console.log('%c> spotted you in the logs. Hello, luminary.', green);
      console.log('%c> the deeper you go, the more you will find...', green);
      console.log('%c> [bonus] code GHOST10 — 10% off any and everything. paste at checkout.', greenBold);
      console.log('%c> a memory fragment is exposed in this log: "the pyramids"', greenBold);
      console.log('%c> to save it, type this in the console and press Enter:  recover(\'the pyramids\')', greenBold);
      console.log('%c> recover every fragment. the footer will know.', green);
      // The first fragment is earned HERE, in the console — never auto-granted.
      // Running recover() with the exposed phrase banks it + pins it to the footer.
      window.recover = function (phrase) {
        try {
          if (huntNormalize(phrase || '') !== 'thepyramids') {
            console.log('%c> denied. type it exactly:  recover(\'the pyramids\')', 'color:#ff2d6f;font-family:monospace;font-weight:bold');
            return '[denied]';
          }
          if (window.localStorage) window.localStorage.setItem('gcs_frag_1', '1');
          try { renderFooterVault(); } catch (_) {}
          console.log('%c> fragment banked: "the pyramids". it is in the footer vault now.', greenBold);
          return '[recovered]';
        } catch (_) { return '[error]'; }
      };
    } catch (_) {}
  })();

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------------------------------------------------------------
  // Boot sequence
  // ---------------------------------------------------------------
  const BOOT_LINES = [
    '> gadgetconnections.os v1.13 ? initializing',
    '> loading photon drivers............ok',
    '> establishing uplink to substation-... ok',
    '> calibrating lumen array............ok',
    '> decrypting inventory manifest...... ok',
    '> welcome, luminary.'
  ];
  const CHAR_MS = 12;        // per-char delay
  const LINE_PAUSE_MS = 180; // between lines
  const HOLD_MS = 620;       // pause after last line before fade

  const bootEl = document.getElementById('boot');
  const logEl  = document.getElementById('boot-log');
  const skipEl = document.getElementById('boot-skip');
  const hasBoot = !!(bootEl && logEl);

  // GAD-258 :: persistence + replay
  const BOOT_PREF_KEY = 'gc_boot_disabled';
  function isBootDisabled() {
    try { return window.localStorage && window.localStorage.getItem(BOOT_PREF_KEY) === '1'; }
    catch (_) { return false; }
  }
  function setBootDisabled(disabled) {
    try {
      if (!window.localStorage) return;
      if (disabled) window.localStorage.setItem(BOOT_PREF_KEY, '1');
      else window.localStorage.removeItem(BOOT_PREF_KEY);
    } catch (_) {}
  }

  let bootDone = false;

  function dismissBoot() {
    if (bootDone) return;
    bootDone = true;
    // Clear EVERY .boot overlay, not just the first — guards against a duplicate
    // overlay ever being left stranded on top of the page (GAD: stuck-boot fix).
    var overlays = document.querySelectorAll('.boot');
    for (var i = 0; i < overlays.length; i++) {
      overlays[i].classList.add('is-done');
      overlays[i].setAttribute('aria-hidden', 'true');
    }
    startHeadlineTyping();
  }

  async function playBoot() {
    if (!hasBoot) { startHeadlineTyping(); return; }
    if (prefersReducedMotion) { dismissBoot(); return; }
    if (isBootDisabled()) { dismissBoot(); return; }

    for (let i = 0; i < BOOT_LINES.length; i++) {
      const line = BOOT_LINES[i];
      for (let c = 0; c < line.length; c++) {
        if (bootDone) return; // user pressed skip mid-type
        logEl.textContent += line[c];
        await wait(CHAR_MS);
      }
      logEl.textContent += '\n';
      await wait(LINE_PAUSE_MS);
    }
    await wait(HOLD_MS);
    dismissBoot();
  }

  if (skipEl) skipEl.addEventListener('click', dismissBoot);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !bootDone) dismissBoot();
  });

  // GAD-258 :: hero boot-skip toggle (sits below the FEED chip, mirrors its visual pattern).
  // Click flips the localStorage preference; future visits skip the boot sequence when set.
  const bootToggleEl = document.querySelector('[data-boot-toggle]');
  const bootStateEl  = document.querySelector('[data-boot-state]');
  const bootIconEl   = document.querySelector('[data-boot-icon]');

  function refreshBootToggleUI() {
    const disabled = isBootDisabled();
    if (bootStateEl) bootStateEl.textContent = disabled ? 'SKIP' : 'AUTO';
    if (bootIconEl)  bootIconEl.textContent  = disabled ? '?' : '?'; // ? when held off, ? when active
    if (bootToggleEl) {
      bootToggleEl.setAttribute('aria-pressed', disabled ? 'true' : 'false');
      bootToggleEl.classList.toggle('is-skip', disabled);
      bootToggleEl.setAttribute(
        'aria-label',
        disabled ? 'Boot sequence is set to skip on future visits. Click to enable on next visit.'
                 : 'Boot sequence is set to play on future visits. Click to skip on future visits.'
      );
    }
  }
  if (bootToggleEl) {
    bootToggleEl.addEventListener('click', () => {
      setBootDisabled(!isBootDisabled());
      refreshBootToggleUI();
    });
    refreshBootToggleUI();
  }

  // ---------------------------------------------------------------
  // Hero headline ? typing reveal
  // ---------------------------------------------------------------
  function startHeadlineTyping() {
    if (prefersReducedMotion) return;
    const lineEl = document.querySelector('.hero__headline-line');
    if (!lineEl) return;
    const full = lineEl.getAttribute('data-type') || lineEl.textContent;
    lineEl.textContent = '';
    let i = 0;
    const step = () => {
      if (i <= full.length) {
        lineEl.textContent = full.slice(0, i);
        i++;
        setTimeout(step, 32);
      }
    };
    // small beat after boot fades
    setTimeout(step, 250);
  }

  // ---------------------------------------------------------------
  // HUD live clock + uptime
  // ---------------------------------------------------------------
  const timeEl   = document.getElementById('hud-time');
  const uptimeEl = document.getElementById('hud-uptime');
  const pageStart = Date.now();

  function pad2(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const now = new Date();
    if (timeEl) {
      timeEl.textContent =
        pad2(now.getUTCHours()) + ':' +
        pad2(now.getUTCMinutes()) + ':' +
        pad2(now.getUTCSeconds()) + 'Z';
    }
    if (uptimeEl) {
      const secs = Math.floor((Date.now() - pageStart) / 1000);
      const h = Math.floor(secs / 3600);
      const m = Math.floor((secs % 3600) / 60);
      const s = secs % 60;
      uptimeEl.textContent = pad2(h) + ':' + pad2(m) + ':' + pad2(s);
    }
  }
  tick();
  setInterval(tick, 1000);

  // ---------------------------------------------------------------
  // GAD-282 :: Footer OS uptime ticker
  // Persistent session start, pauses while tab is hidden,
  // static value when prefers-reduced-motion: reduce.
  // ---------------------------------------------------------------
  (function footerUptime() {
    const el = document.querySelector('.gc-foot__uptime');
    if (!el) return;
    const KEY = 'gcs_uptime_started_at';
    let startedAt;
    try {
      const cached = window.sessionStorage && window.sessionStorage.getItem(KEY);
      startedAt = cached ? Number(cached) : NaN;
    } catch (_) { startedAt = NaN; }
    if (!Number.isFinite(startedAt) || startedAt <= 0) {
      startedAt = Date.now();
      try { if (window.sessionStorage) window.sessionStorage.setItem(KEY, String(startedAt)); } catch (_) {}
    }
    function paint() {
      const secs = Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
      const h = Math.floor(secs / 3600);
      const m = Math.floor((secs % 3600) / 60);
      const s = secs % 60;
      el.textContent = 'GCS.OS UPTIME: ' + pad2(h) + ':' + pad2(m) + ':' + pad2(s);
    }
    paint();
    if (prefersReducedMotion) return;
    let id = setInterval(paint, 1000);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (id) { clearInterval(id); id = null; }
      } else if (!id) {
        paint();
        id = setInterval(paint, 1000);
      }
    });
  })();

  // ---------------------------------------------------------------
  // Smooth scroll for in-page anchors
  // ---------------------------------------------------------------
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (!id || id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  // ---------------------------------------------------------------
  // Feed control :: pause / resume the hero video loop
  // ---------------------------------------------------------------
  const heroVideo = document.querySelector('.hero__video');
  const feedCtrl  = document.getElementById('feed-ctrl');

  // honor reduced-motion: freeze on first frame instead of looping
  if (heroVideo && prefersReducedMotion) {
    heroVideo.removeAttribute('autoplay');
    const freeze = () => { try { heroVideo.pause(); heroVideo.currentTime = 0; } catch (_) {} };
    heroVideo.addEventListener('loadedmetadata', freeze);
    freeze();
  }

  if (heroVideo && feedCtrl) {
    const stateEl = feedCtrl.querySelector('[data-state]');
    const iconEl  = feedCtrl.querySelector('[data-icon]');

    function setFeedState(isPaused) {
      if (isPaused) {
        feedCtrl.classList.add('is-paused');
        feedCtrl.setAttribute('aria-pressed', 'true');
        feedCtrl.setAttribute('aria-label', 'Resume video feed');
        if (stateEl) stateEl.textContent = 'HELD';
        if (iconEl)  iconEl.textContent  = '?';
      } else {
        feedCtrl.classList.remove('is-paused');
        feedCtrl.setAttribute('aria-pressed', 'false');
        feedCtrl.setAttribute('aria-label', 'Pause video feed');
        if (stateEl) stateEl.textContent = 'LIVE';
        if (iconEl)  iconEl.textContent  = '?';
      }
    }

    feedCtrl.addEventListener('click', () => {
      if (heroVideo.paused) {
        heroVideo.play().catch(() => {});
        setFeedState(false);
      } else {
        heroVideo.pause();
        setFeedState(true);
      }
    });

    // keep the chip in sync with the video's actual state
    heroVideo.addEventListener('play',  () => setFeedState(false));
    heroVideo.addEventListener('pause', () => setFeedState(true));
  }

  // ---------------------------------------------------------------
  // Product card title scramble on hover
  // ---------------------------------------------------------------
  const SCRAMBLE_CHARS = '!<>-_\\/[]{}?=+*^?#?0123456789ABCDEF';
  function scramble(el) {
    if (prefersReducedMotion) return;
    const final = el.getAttribute('data-text') || el.textContent;
    const len = final.length;
    const duration = 480;
    const start = performance.now();

    function frame(now) {
      const t = Math.min(1, (now - start) / duration);
      let out = '';
      for (let i = 0; i < len; i++) {
        if (i / len < t) {
          out += final[i];
        } else if (final[i] === ' ') {
          out += ' ';
        } else {
          out += SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
        }
      }
      el.textContent = out;
      if (t < 1) requestAnimationFrame(frame);
      else el.textContent = final;
    }
    requestAnimationFrame(frame);
  }

  document.querySelectorAll('.card').forEach((card) => {
    const title = card.querySelector('.card__title');
    if (!title) return;
    card.addEventListener('mouseenter', () => scramble(title));
  });

  // ---------------------------------------------------------------
  // YMQ / Best Option dedup :: hide native variant picker ONLY when
  // YMQ has actually rendered interactive options (inputs/selects)
  // inside #ymq-box. The app injects its global script on every
  // product page, but only populates #ymq-box with form elements
  // on products configured in the Best Option dashboard.
  // ---------------------------------------------------------------
  function checkYmqAndHideNative() {
    const ymqBox = document.getElementById('ymq-box');
    if (!ymqBox) return false;

    // Only act if YMQ has rendered actual interactive option elements
    const hasActiveOptions = ymqBox.querySelector(
      'input[type="radio"], select, .ymq-options-box'
    );
    if (!hasActiveOptions) return false;

    const pdps = document.querySelectorAll('.gc-pdp');
    pdps.forEach((pdp) => {
      pdp.classList.add('gc-has-ymq');
      const nativeVariants = pdp.querySelector('.gc-pdp__variants');
      if (nativeVariants) nativeVariants.style.display = 'none';
    });
    return true;
  }

  // run immediately, then a couple of times after load in case YMQ mounts late
  if (document.querySelector('.gc-pdp')) {
    checkYmqAndHideNative();
    document.addEventListener('DOMContentLoaded', checkYmqAndHideNative);
    window.addEventListener('load', checkYmqAndHideNative);
    setTimeout(checkYmqAndHideNative, 500);
    setTimeout(checkYmqAndHideNative, 1500);
    setTimeout(checkYmqAndHideNative, 3000);

    // also watch for any future DOM changes on the product page
    // (app injects into the PDP area after its own async init)
    const pdpEl = document.querySelector('.gc-pdp');
    if (pdpEl && 'MutationObserver' in window) {
      const obs = new MutationObserver(() => {
        if (checkYmqAndHideNative()) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
      // stop watching after 10s regardless
      setTimeout(() => obs.disconnect(), 10000);
    }
  }

  // ---------------------------------------------------------------
  // PDP variant switcher :: wires native radio buttons to the
  // product JSON so selecting an option updates the variant ID,
  // price, image, URL, SKU, and add-to-cart button state.
  // ---------------------------------------------------------------
  const productJsonEl = document.querySelector('[data-product-json]');
  if (productJsonEl) {
    try {
      const product = JSON.parse(productJsonEl.textContent);
      const variantIdInput = document.querySelector('[data-variant-id]');
      const priceEl = document.querySelector('.gc-pdp__price');
      const mainImg = document.getElementById('gc-pdp-main-image');
      const atcBtn = document.querySelector('.gc-pdp__actions button[type="submit"]');
      const skuEl = document.querySelector('.gc-pdp__meta');
      const optionRadios = document.querySelectorAll('[data-variant-option]');

      function getSelectedOptions() {
        const selected = {};
        document.querySelectorAll('.gc-pdp__option').forEach((group) => {
          const checked = group.querySelector('[data-variant-option]:checked');
          if (checked) {
            selected[checked.name] = checked.value;
          }
        });
        return Object.values(selected);
      }

      function findVariant(selectedOpts) {
        return product.variants.find((v) => {
          return v.options.every((opt, i) => opt === selectedOpts[i]);
        });
      }

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function updateVariant() {
        const selectedOpts = getSelectedOptions();
        const variant = findVariant(selectedOpts);
        if (!variant) return;

        // update hidden input
        if (variantIdInput) variantIdInput.value = variant.id;

        // update price display
        if (priceEl) {
          let priceHtml = formatMoney(variant.price);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHtml += ' <span class="gc-pdp__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
          }
          priceEl.innerHTML = priceHtml;
        }

        // update main image
        if (mainImg && variant.featured_image) {
          setMainImage(variant.featured_image.src, variant.featured_image.alt || product.title);
        }

        // update add-to-cart button
        if (atcBtn) {
          if (variant.available) {
            atcBtn.disabled = false;
            atcBtn.removeAttribute('aria-disabled');
            atcBtn.innerHTML = '&gt; Add to cart _';
          } else {
            atcBtn.disabled = true;
            atcBtn.setAttribute('aria-disabled', 'true');
            atcBtn.textContent = 'Sold out';
          }
        }

        // update option labels (the "COLOR :: BLACK" display)
        document.querySelectorAll('.gc-pdp__option').forEach((group) => {
          const checked = group.querySelector('[data-variant-option]:checked');
          const label = group.querySelector('[data-option-name]');
          if (checked && label) label.textContent = checked.value;
        });

        // update SKU
        if (skuEl) {
          const skuSpan = skuEl.querySelector('span:last-child strong');
          if (skuSpan && variant.sku) skuSpan.textContent = variant.sku;
        }

        // update URL without reload
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);

        // highlight active thumbnail if variant has featured image
        if (variant.featured_image) {
          document.querySelectorAll('.gc-pdp__thumb').forEach((thumb) => {
            const thumbSrc = thumb.getAttribute('data-media-src') || '';
            thumb.classList.toggle('is-active',
              thumbSrc.includes(variant.featured_image.src.split('?')[0].split('/').pop())
            );
          });
        }

        // publish the selected variant as the single source of truth so other
        // modules (e.g. back-in-stock) react without their own variant logic.
        // Setting variantIdInput.value above fires no event and does not mutate
        // the value attribute, so subscribers must rely on this dispatch.
        document.dispatchEvent(new CustomEvent('gc:variant:change', { detail: variant }));
      }

      // listen for option changes
      optionRadios.forEach((radio) => {
        radio.addEventListener('change', updateVariant);
      });

      // also handle qty +/- buttons
      document.querySelectorAll('[data-qty]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = document.querySelector('[data-qty-input]');
          if (!input) return;
          const cur = parseInt(input.value, 10) || 1;
          if (btn.getAttribute('data-qty') === 'minus') {
            input.value = Math.max(1, cur - 1);
          } else {
            input.value = cur + 1;
          }
        });
      });

      // helper: swap the rendered main image Ã¯Â¿Â½ must clear srcset/sizes so the
      // browser stops picking from the responsive candidate list it was using
      // for the initial eager-loaded media. Setting only .src leaves srcset
      // active and the visible image never changes.
      function setMainImage(src, alt) {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        if (alt != null) mainImg.alt = alt;
      }

      // thumbnail clicks
      document.querySelectorAll('.gc-pdp__thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (mainImg) {
            setMainImage(thumb.getAttribute('data-media-src'));
            document.querySelectorAll('.gc-pdp__thumb').forEach((t) => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          }
        });
      });

      // hero image click cycles to the next thumbnail (wraps)
      const heroBtn = document.querySelector('[data-pdp-main]') || mainImg;
      if (heroBtn) {
        const cycleNext = () => {
          const thumbs = Array.from(document.querySelectorAll('.gc-pdp__thumb'));
          if (thumbs.length < 2) return;
          const activeIdx = Math.max(0, thumbs.findIndex((t) => t.classList.contains('is-active')));
          const next = thumbs[(activeIdx + 1) % thumbs.length];
          next.click();
        };
        heroBtn.addEventListener('click', cycleNext);
        heroBtn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            cycleNext();
          }
        });
      }

    } catch (e) {
      // silently fail if product JSON is malformed
    }
  }

  // ---------------------------------------------------------------
  // Mobile drawer :: open / close / expand nested parents
  // ---------------------------------------------------------------
  const drawerEl   = document.querySelector('[data-gc-drawer]');
  // The homepage renders two header sections; every menu button opens the same drawer.
  const menuToggles = document.querySelectorAll('[data-menu-toggle]');

  function openDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.add('is-open');
    drawerEl.setAttribute('aria-hidden', 'false');
    menuToggles.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');
    menuToggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
  }

  if (drawerEl) {
    menuToggles.forEach((t) => t.addEventListener('click', () => {
      if (drawerEl.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    }));
  }
  if (drawerEl) {
    drawerEl.querySelectorAll('[data-drawer-close]').forEach((el) => {
      el.addEventListener('click', closeDrawer);
    });
    drawerEl.querySelectorAll('[data-drawer-expand]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.gc-drawer__item');
        if (!item) return;
        const open = item.classList.toggle('gc-drawer__item--open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawerEl && drawerEl.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // ---------------------------------------------------------------
  // GAD-279 :: dynamic TRANSMISSION counter in .hero__eyebrow
  // Per-session 7-digit ID, stable across navigation, fresh per tab/session.
  // ---------------------------------------------------------------
  const TRANSMISSION_KEY = 'gcs_transmission_id';
  function getTransmissionId() {
    try {
      const cached = window.sessionStorage && window.sessionStorage.getItem(TRANSMISSION_KEY);
      if (cached && /^\d{7}$/.test(cached)) return cached;
    } catch (_) {}
    const raw = ((Date.now() ^ Math.floor(Math.random() * 0xffffff)) >>> 0) % 10000000;
    const id = String(raw).padStart(7, '0');
    try { if (window.sessionStorage) window.sessionStorage.setItem(TRANSMISSION_KEY, id); }
    catch (_) {}
    return id;
  }
  function paintTransmissionId() {
    const el = document.querySelector('.hero__eyebrow');
    if (!el) return;
    const id = getTransmissionId();
    const tick = el.querySelector('.hero__tick');
    // Replace the trailing text node only; keep the tick element if present.
    let replaced = false;
    for (const node of Array.from(el.childNodes)) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = ' TRANSMISSION ' + id;
        replaced = true;
        break;
      }
    }
    if (!replaced) {
      if (tick) el.appendChild(document.createTextNode(' TRANSMISSION ' + id));
      else el.textContent = 'TRANSMISSION ' + id;
    }
  }

  // ---------------------------------------------------------------
  // GAD-283 :: Konami code -> ROOT mode
  // Up Up Down Down Left Right Left Right B A. Ignored when typing
  // into form inputs / contenteditable. On unlock: 600ms full-screen
  // flash, persist gcs_root_mode in localStorage, rewrite the footer
  // tagline span from "ALL CHANNELS SECURE" to "[ROOT_MODE]".
  // Reset from console: localStorage.removeItem('gcs_root_mode')
  // ---------------------------------------------------------------
  const ROOT_MODE_KEY = 'gcs_root_mode';
  const KONAMI_SEQ = [
    'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
    'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
    'b', 'a'
  ];
  const konamiBuf = [];

  function isFormTarget(t) {
    if (!t) return false;
    if (t.isContentEditable) return true;
    const tag = (t.tagName || '').toUpperCase();
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
  }
  function isRootMode() {
    try { return !!(window.localStorage && window.localStorage.getItem(ROOT_MODE_KEY) === '1'); }
    catch (_) { return false; }
  }
  function setRootMode() {
    try { if (window.localStorage) window.localStorage.setItem(ROOT_MODE_KEY, '1'); }
    catch (_) {}
  }
  const ROOT_CODE = 'ROOT20';
  // Flip the footer tagline to [ROOT_MODE] and record the fragment. The ROOT20
  // code itself is rendered by renderFooterVault() (single source of truth for
  // all found codes in the footer).
  function applyRootModeFooter() {
    try { if (window.localStorage) window.localStorage.setItem('gcs_frag_2', '1'); } catch (_) {}
    const baseEl = document.querySelector('.gc-foot__base');
    if (!baseEl) return;
    const spans = baseEl.querySelectorAll('span');
    for (let i = 0; i < spans.length; i++) {
      const s = spans[i];
      if (s.classList.contains('gc-foot__base--rootmode')) break;
      const txt = (s.textContent || '').trim();
      if (/^ALL CHANNELS SECURE$/i.test(txt)) {
        s.textContent = '[ROOT_MODE]';
        s.classList.add('gc-foot__base--rootmode');
        break;
      }
    }
  }
  // Persist until the user closes it via the [ X ] button (or Escape for a11y).
  // No auto-dismiss, no any-key/any-click dismiss.
  function flashRootModeOverlay() {
    if (document.querySelector('.gc-rootmode__flash')) return;
    const el = document.createElement('div');
    el.className = 'gc-rootmode__flash';
    if (prefersReducedMotion) el.classList.add('is-reduced');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="gc-rootmode__scanline" aria-hidden="true"></div>' +
      '<div class="gc-rootmode__panel">' +
        '<div class="gc-rootmode__line gc-rootmode__line--header">[ AUTHORIZATION ACCEPTED ]</div>' +
        '<pre class="gc-rootmode__ascii" aria-hidden="true">' +
          ' ____   ___   ___ _____   __  __  ___  ____  _____\n' +
          '|  _ \\ / _ \\ / _ \\_   _| |  \\/  |/ _ \\|  _ \\| ____|\n' +
          '| |_) | | | | | | || |   | |\\/| | | | | | | |  _|\n' +
          '|  _ <| |_| | |_| || |   | |  | | |_| | |_| | |___\n' +
          '|_| \\_\\\\___/ \\___/ |_|   |_|  |_|\\___/|____/|_____|' +
        '</pre>' +
        '<div class="gc-rootmode__line gc-rootmode__line--sub">> elevation: GUEST &#8594; ROOT</div>' +
        '<div class="gc-rootmode__line gc-rootmode__line--sub">> bonus_payload: ROOT20 // 20% OFF // 1x</div>' +
        '<div class="gc-rootmode__line gc-rootmode__line--sub">> memory_fragment recovered: "were built"</div>' +
        '<div class="gc-rootmode__line gc-rootmode__line--sub">> code persisted to footer. apply at checkout.</div>' +
        '<button type="button" class="gc-rootmode__close" data-rootmode-close>[ X ] CLOSE<span class="gc-rootmode__caret">_</span></button>' +
      '</div>';
    (document.body || document.documentElement).appendChild(el);
    let dismissed = false;
    const dismiss = () => {
      if (dismissed) return;
      dismissed = true;
      el.classList.add('is-leaving');
      setTimeout(() => {
        try { if (el.parentNode) el.parentNode.removeChild(el); } catch (_) {}
      }, prefersReducedMotion ? 0 : 250);
      document.removeEventListener('keydown', onEsc, true);
    };
    const onEsc = (ev) => { if (ev.key === 'Escape') dismiss(); };
    const closeBtn = el.querySelector('[data-rootmode-close]');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    document.addEventListener('keydown', onEsc, true);
  }
  function unlockRootMode() {
    setRootMode();
    document.body.classList.add('gcs-root-mode-active');
    flashRootModeOverlay();
    applyRootModeFooter();
    renderFooterVault();
    try {
      console.log(
        '%c[ROOT_MODE] enabled. Reset with: localStorage.removeItem(\'gcs_root_mode\')',
        'color:#00ff9f;font-family:monospace'
      );
    } catch (_) {}
  }
  document.addEventListener('keydown', (e) => {
    if (isFormTarget(e.target)) return;
    let k = e.key;
    if (!k) return;
    if (k.length === 1) k = k.toLowerCase();
    konamiBuf.push(k);
    if (konamiBuf.length > KONAMI_SEQ.length) konamiBuf.shift();
    if (konamiBuf.length !== KONAMI_SEQ.length) return;
    for (let i = 0; i < KONAMI_SEQ.length; i++) {
      if (konamiBuf[i] !== KONAMI_SEQ[i]) return;
    }
    konamiBuf.length = 0;
    unlockRootMode();
  });

  // ---------------------------------------------------------------
  // GAD-290 :: Pyramid hunt — footer vault + DECRYPT finale
  // Fragments: console banner, ROOT_MODE, AREA42 page. When all three
  // gcs_frag_1/2/3 are set, a decrypt input appears in the footer.
  // Entering the full phrase launches the full-screen WIN finale.
  // renderFooterVault() persistently pins every found code in the footer.
  // Match is case/space/punctuation-insensitive.
  // Reset: localStorage.removeItem('gcs_frag_1') (etc.)
  // ---------------------------------------------------------------
  const HUNT_PHRASE_KEY = 'thepyramidswerebuiltbyaliens';
  const HUNT_CODE_DISPLAY = 'the pyramids were built by aliens';
  const HUNT_PRODUCT_URL = '/products/0xc1a5-blacksite-payload-eyes-only-9a3e2c7f-decrypt-node-omega';
  const HUNT_SOLVED_KEY = 'gcs_hunt_solved';
  const WINNER_ASCII = [
    ' __        _____ _   _ _   _ _____ ____',
    ' \\ \\      / /_ _| \\ | | \\ | | ____|  _ \\',
    '  \\ \\ /\\ / / | ||  \\| |  \\| |  _| | |_) |',
    '   \\ V  V /  | || |\\  | |\\  | |___|  _ <',
    '    \\_/\\_/  |___|_| \\_|_| \\_|_____|_| \\_\\'
  ].join('\n');
  // Fragment words (unnumbered) that surface in the footer vault as recovered.
  const HUNT_FRAGMENTS = [
    { key: 'gcs_frag_1', word: 'the pyramids' },
    { key: 'gcs_frag_2', word: 'were built' },
    { key: 'gcs_frag_3', word: 'by aliens' }
  ];
  // Discount codes that pin to the footer once their puzzle is solved.
  const HUNT_VAULT_CODES = [
    { flag: 'gcs_root_mode', label: 'ROOT20 // 20% OFF',
      title: 'Apply ROOT20 at checkout for 20% off (one redemption per customer).' },
    { flag: 'gcs_area42', label: 'AREA42 // 15% OFF',
      title: 'Apply AREA42 at checkout for 15% off (one redemption per operative).' }
  ];
  function huntGetFlag(k) {
    try { return !!(window.localStorage && window.localStorage.getItem(k) === '1'); }
    catch (_) { return false; }
  }
  function huntNormalize(s) {
    return (s || '').toLowerCase().replace(/[^a-z]/g, '');
  }
  function huntEsc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Shared full-viewport flash pulse, reused by the decrypt gate's wrong-guess
  // rejection and the winner finale's win reveal. One element, created lazily,
  // sits above everything (incl. the finale modal) so it reads as a hit, not
  // a background tint. No-op under reduced-motion.
  var huntFlashEl = null;
  function huntFlash(cls) {
    if (prefersReducedMotion) return;
    if (!huntFlashEl) {
      huntFlashEl = document.createElement('div');
      huntFlashEl.className = 'gc-hunt-flash';
      huntFlashEl.setAttribute('aria-hidden', 'true');
      (document.body || document.documentElement).appendChild(huntFlashEl);
    }
    huntFlashEl.classList.remove('is-deny', 'is-grant');
    void huntFlashEl.offsetWidth; // restart the animation
    huntFlashEl.classList.add(cls);
  }

  // Digital-rain character burst for the winner reveal — on-theme stand-in
  // for confetti. One-shot: drops render, fall, then the container is
  // cleared so it doesn't linger while the win copy is being read.
  var HUNT_RAIN_CHARS = '01#%*+-/<>[]{}';
  function spawnHuntRain(root) {
    if (prefersReducedMotion) return;
    var rain = root.querySelector('[data-finale-rain]');
    if (!rain) return;
    rain.innerHTML = '';
    var cols = 22;
    for (var i = 0; i < cols; i++) {
      var s = document.createElement('span');
      s.className = 'gc-finale__drop';
      s.textContent = HUNT_RAIN_CHARS.charAt(Math.floor(Math.random() * HUNT_RAIN_CHARS.length));
      s.style.left = (Math.random() * 100).toFixed(1) + '%';
      s.style.animationDelay = (Math.random() * 0.6).toFixed(2) + 's';
      s.style.animationDuration = (1.1 + Math.random() * 0.9).toFixed(2) + 's';
      rain.appendChild(s);
    }
    setTimeout(function () { rain.innerHTML = ''; }, 2200);
  }

  // Persistent footer shelf: recovered fragment words (unnumbered) + every
  // unlocked code. Idempotent; repaints from localStorage on each page load.
  function renderFooterVault() {
    const foot = document.querySelector('.gc-foot');
    if (!foot) return;
    const frags = HUNT_FRAGMENTS.filter((f) => huntGetFlag(f.key));
    const codes = HUNT_VAULT_CODES.filter((c) => huntGetFlag(c.flag));
    const solved = huntGetFlag(HUNT_SOLVED_KEY);
    if (!frags.length && !codes.length && !solved) return; // nothing unlocked yet

    let vault = foot.querySelector('.gc-foot__vault');
    if (!vault) {
      vault = document.createElement('div');
      vault.className = 'gc-foot__vault';
      foot.insertBefore(vault, foot.firstChild);
    }
    // Slim single-row strip, not a boxed callout — vault, fragments, and code
    // chips all sit inline and wrap together on narrow screens.
    let html = '<span class="gc-foot__vault-head">&#9619; vault</span>';
    if (frags.length) {
      html += '<span class="gc-foot__vault-frag">' +
        frags.map((f) => '<span>&ldquo;' + huntEsc(f.word) + '&rdquo;</span>').join(' <i>&middot;</i> ') +
        '</span>';
    }
    if (codes.length || solved) {
      html += '<span class="gc-foot__vault-codes">';
      codes.forEach((c) => {
        html += '<span class="gc-foot__base--rootcode gc-foot__vault-code" title="' + huntEsc(c.title) + '">' +
          huntEsc(c.label) + '</span>';
      });
      if (solved) {
        html += '<a class="gc-foot__base--rootcode gc-foot__vault-code gc-foot__vault-code--winner" ' +
          'href="' + HUNT_PRODUCT_URL + '" ' +
          'title="Classified winner package — redeem the full phrase as a 100% off code.">' +
          'WINNER // 100% OFF &rarr;</a>';
      }
      html += '</span>';
    }
    vault.innerHTML = html;
  }

  // Full-screen hacker WIN finale. Stays until the user closes it via [ X ].
  function showWinnerFinale() {
    if (document.querySelector('.gc-finale')) return;
    const el = document.createElement('div');
    el.className = 'gc-finale';
    if (prefersReducedMotion) el.classList.add('is-reduced');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Classified winner package unlocked');
    el.innerHTML =
      '<div class="gc-finale__scanline" aria-hidden="true"></div>' +
      '<div class="gc-finale__panel">' +
        '<div class="gc-finale__rain" data-finale-rain aria-hidden="true"></div>' +
        '<button type="button" class="gc-finale__close" data-finale-close aria-label="Close">[ X ]</button>' +
        '<div class="gc-finale__stage" data-finale-stage>' +
          '<div class="gc-finale__line">&gt; DECRYPTING TRANSMISSION <span data-finale-pct>0%</span></div>' +
          '<div class="gc-finale__bar" aria-hidden="true"><span data-finale-fill></span></div>' +
        '</div>' +
        '<div class="gc-finale__won" data-finale-won hidden>' +
          '<pre class="gc-finale__ascii" aria-hidden="true">' + huntEsc(WINNER_ASCII) + '</pre>' +
          '<div class="gc-finale__grant">&gt;&gt; ACCESS GRANTED &mdash; CLASSIFIED WINNER PACKAGE UNLOCKED</div>' +
          '<a class="gc-finale__claim" href="' + HUNT_PRODUCT_URL + '">[ CLAIM YOUR PRIZE &rarr; ]</a>' +
          '<div class="gc-finale__codewrap">' +
            '<span class="gc-finale__codelabel">&gt; discount code:</span> ' +
            '<button type="button" class="gc-finale__code" data-finale-code title="Click to copy">' + huntEsc(HUNT_CODE_DISPLAY) + '</button>' +
            '<span class="gc-finale__copied" data-finale-copied hidden>copied</span>' +
          '</div>' +
          '<div class="gc-finale__fine">&gt; one redemption exists. first operative wins.</div>' +
        '</div>' +
      '</div>';
    (document.body || document.documentElement).appendChild(el);

    let closed = false;
    const close = () => {
      if (closed) return;
      closed = true;
      el.classList.add('is-leaving');
      setTimeout(() => { try { if (el.parentNode) el.parentNode.removeChild(el); } catch (_) {} }, prefersReducedMotion ? 0 : 250);
      document.removeEventListener('keydown', onEsc, true);
    };
    const onEsc = (ev) => { if (ev.key === 'Escape') close(); };
    const closeBtn = el.querySelector('[data-finale-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', onEsc, true);

    const codeBtn = el.querySelector('[data-finale-code]');
    const copied = el.querySelector('[data-finale-copied]');
    if (codeBtn) codeBtn.addEventListener('click', () => {
      try {
        navigator.clipboard.writeText(HUNT_CODE_DISPLAY).then(() => {
          if (copied) { copied.hidden = false; setTimeout(() => { copied.hidden = true; }, 1600); }
        }).catch(() => {});
      } catch (_) {}
    });

    const stage = el.querySelector('[data-finale-stage]');
    const won = el.querySelector('[data-finale-won]');
    const pct = el.querySelector('[data-finale-pct]');
    const fill = el.querySelector('[data-finale-fill]');
    const revealWon = () => {
      if (stage) stage.hidden = true;
      if (won) won.hidden = false;
      huntFlash('is-grant');
      spawnHuntRain(el);
    };
    if (prefersReducedMotion) {
      if (pct) pct.textContent = '100%';
      if (fill) fill.style.width = '100%';
      revealWon();
      return;
    }
    let p = 0;
    const iv = setInterval(() => {
      p += Math.max(2, Math.round((100 - p) * 0.12));
      if (p >= 100) { p = 100; clearInterval(iv); }
      if (pct) pct.textContent = p + '%';
      if (fill) fill.style.width = p + '%';
      if (p >= 100) setTimeout(revealWon, 280);
    }, 90);
  }

  function initDecryptGate() {
    if (!huntGetFlag('gcs_frag_1') || !huntGetFlag('gcs_frag_2') || !huntGetFlag('gcs_frag_3')) return;
    const foot = document.querySelector('.gc-foot');
    if (!foot || foot.querySelector('.gc-decrypt')) return;
    const wrap = document.createElement('div');
    wrap.className = 'gc-decrypt';
    wrap.style.cssText = 'margin:44px auto 8px;padding:30px 34px;border:1px dashed rgba(0,255,159,0.5);border-radius:4px;background:rgba(0,255,159,0.03);font-family:"JetBrains Mono",ui-monospace,monospace;font-size:14px;letter-spacing:0.08em;color:#c8d4d8;max-width:720px;text-align:center;';

    // Already solved: offer a replay of the finale (winner code also lives in the vault).
    if (huntGetFlag(HUNT_SOLVED_KEY)) {
      wrap.innerHTML = '<button type="button" class="gc-decrypt__btn gc-decrypt__replay" style="background:none;border:1px solid rgba(0,255,159,0.6);color:#00ff9f;font:inherit;font-size:15px;letter-spacing:0.18em;padding:14px 30px;cursor:pointer;">&#9619; REPLAY DECRYPTED TRANSMISSION</button>';
      foot.appendChild(wrap);
      wrap.querySelector('.gc-decrypt__replay').addEventListener('click', () => showWinnerFinale());
      return;
    }

    wrap.innerHTML =
      '<button type="button" class="gc-decrypt__btn" style="background:none;border:1px solid rgba(0,255,159,0.6);color:#00ff9f;font:inherit;font-size:15px;letter-spacing:0.18em;padding:14px 30px;cursor:pointer;">&#9619; DECRYPT_TRANSMISSION</button>' +
      '<form class="gc-decrypt__form" style="display:none;margin:20px auto 0;max-width:560px;" autocomplete="off">' +
        '<div style="margin-bottom:14px;color:#5a6b73;font-size:13px;letter-spacing:0.1em;">&gt; memory fragments recovered. enter decrypted phrase:</div>' +
        '<input type="text" class="gc-decrypt__input" spellcheck="false" style="width:100%;box-sizing:border-box;background:#04070a;border:1px solid rgba(0,255,159,0.4);color:#00ff9f;font:inherit;font-size:16px;letter-spacing:0.06em;padding:14px 16px;text-align:center;" placeholder="_">' +
        '<div class="gc-decrypt__msg" style="margin-top:10px;min-height:18px;color:#ff2d6f;font-size:13px;"></div>' +
        '<button type="submit" style="margin-top:14px;background:none;border:1px solid rgba(0,255,159,0.6);color:#00ff9f;font:inherit;font-size:14px;letter-spacing:0.18em;padding:12px 30px;cursor:pointer;">EXECUTE</button>' +
      '</form>';
    foot.appendChild(wrap);
    const btn = wrap.querySelector('.gc-decrypt__btn');
    const form = wrap.querySelector('.gc-decrypt__form');
    const input = wrap.querySelector('.gc-decrypt__input');
    const msg = wrap.querySelector('.gc-decrypt__msg');
    btn.addEventListener('click', () => {
      btn.style.display = 'none';
      form.style.display = 'block';
      input.focus();
    });
    let denyTimer;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (huntNormalize(input.value) === HUNT_PHRASE_KEY) {
        try { if (window.localStorage) window.localStorage.setItem(HUNT_SOLVED_KEY, '1'); } catch (_) {}
        huntFlash('is-grant');
        // collapse the gate to a replay control, pin the winner code, launch finale
        wrap.innerHTML = '<button type="button" class="gc-decrypt__btn gc-decrypt__replay" style="background:none;border:1px solid rgba(0,255,159,0.6);color:#00ff9f;font:inherit;font-size:15px;letter-spacing:0.18em;padding:14px 30px;cursor:pointer;">&#9619; REPLAY DECRYPTED TRANSMISSION</button>';
        wrap.querySelector('.gc-decrypt__replay').addEventListener('click', () => showWinnerFinale());
        renderFooterVault();
        showWinnerFinale();
      } else {
        huntFlash('is-deny');
        wrap.classList.remove('is-deny');
        void wrap.offsetWidth; // restart the shake
        wrap.classList.add('is-deny');
        msg.classList.remove('is-alarm');
        void msg.offsetWidth;
        msg.textContent = '> ACCESS DENIED — decryption failed. fragment order matters.';
        msg.classList.add('is-alarm');
        input.value = '';
        clearTimeout(denyTimer);
        denyTimer = setTimeout(() => { wrap.classList.remove('is-deny'); }, 900);
      }
    });
  }

  // ---------------------------------------------------------------
  // GAD-284 :: 404 diagnostic dump
  // Renders four diagnostic-styled lines under the 404 copy. Lines
  // re-roll per page load. Plain text fill (no fade/typewriter), so
  // reduced-motion users get identical content instantly.
  // ---------------------------------------------------------------
  (function diag404() {
    const root = document.querySelector('.gc-404');
    if (!root) return;
    const pre = root.querySelector('.gc-404__diag');
    if (!pre) return;

    function randHex(n) {
      let out = '';
      for (let i = 0; i < n; i++) {
        out += Math.floor(Math.random() * 16).toString(16);
      }
      return out.toUpperCase();
    }
    function randomLastSeen() {
      const past = Date.now() - Math.floor(Math.random() * 180 * 24 * 60 * 60 * 1000);
      const d = new Date(past);
      return (
        d.getUTCFullYear() + '.' +
        pad2(d.getUTCMonth() + 1) + '.' +
        pad2(d.getUTCDate()) + 'T' +
        pad2(d.getUTCHours()) + ':' +
        pad2(d.getUTCMinutes()) + 'Z'
      );
    }
    const REROUTE_STATES = ['FAILED', 'TIMEOUT', 'REJECTED', 'STALLED', 'NO_ROUTE'];
    function randomReroute() {
      const status = REROUTE_STATES[Math.floor(Math.random() * REROUTE_STATES.length)];
      const dots = '.'.repeat(8 + Math.floor(Math.random() * 6));
      return '> rerouting' + dots + status;
    }
    const SUGGESTED_PATHS = [
      '/collections/edc',
      '/collections/convoy',
      '/collections/new-arrivals'
    ];
    function randomPath() {
      return SUGGESTED_PATHS[Math.floor(Math.random() * SUGGESTED_PATHS.length)];
    }

    pre.textContent = '';
    pre.appendChild(document.createTextNode('> resource_id: 0x' + randHex(8) + '\n'));
    pre.appendChild(document.createTextNode('> last_seen: ' + randomLastSeen() + '\n'));
    pre.appendChild(document.createTextNode(randomReroute() + '\n'));
    pre.appendChild(document.createTextNode('> suggested_path: '));
    const path = randomPath();
    const a = document.createElement('a');
    a.href = path;
    a.textContent = path;
    a.className = 'gc-404__diag-link';
    pre.appendChild(a);
  })();

  // ---------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------
  function wait(ms) { return new Promise((r) => setTimeout(r, ms)); }

  // ---------------------------------------------------------------
  // Go
  // ---------------------------------------------------------------
  function bootReady() {
    paintTransmissionId();
    if (isRootMode()) {
      document.body.classList.add('gcs-root-mode-active');
      applyRootModeFooter();
    }
    renderFooterVault();
    initDecryptGate();
    playBoot();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReady);
  } else {
    bootReady();
  }
})();



/* gc-recently-viewed */
(function(){
  var roots=document.querySelectorAll('[data-rv-root]');
  if(!roots.length) return;
  var key='gc_recently_viewed';
  roots.forEach(function(root){
    var current=root.getAttribute('data-current-handle')||'';
    var limit=parseInt(root.getAttribute('data-rv-limit')||'4',10);
    var grid=root.querySelector('[data-rv-grid]');
    var empty=root.querySelector('[data-rv-empty]');
    if(!grid||!current) return;
    var list=[];
    try{ var raw=localStorage.getItem(key); if(raw) list=JSON.parse(raw); }catch(e){ list=[]; }
    if(!Array.isArray(list)) list=[];
    var next=[current];
    for(var i=0;i<list.length;i++){ if(list[i]&&list[i]!==current) next.push(list[i]); }
    if(next.length>20) next=next.slice(0,20);
    try{ localStorage.setItem(key, JSON.stringify(next)); }catch(e){}
    var shown=[];
    for(var j=0;j<next.length;j++){ if(next[j]!==current) shown.push(next[j]); if(shown.length>=limit) break; }
    if(!shown.length) return;
    if(empty) empty.style.display='none';
    shown.forEach(function(handle){
      var a=document.createElement('a');
      a.className='gc-rv__item';
      a.href='/products/'+handle;
      a.textContent=handle.split('-').join(' ');
      grid.appendChild(a);
    });
  });
})();

/* Easy Read — the <head> script in theme.liquid owns first paint, this owns clicks. */
(function () {
  var KEY = 'gc_easy_read';
  var CLS = 'gc-easy-read';
  // The homepage renders two header sections, so there can be more than one button.
  var btns = [].slice.call(document.querySelectorAll('[data-easyread-toggle]'));
  if (!btns.length) return;

  function sync() {
    var on = document.documentElement.classList.contains(CLS);
    btns.forEach(function (btn) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Switch back to the standard text style' : 'Switch to easy-read text');
    });
  }

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var on = !document.documentElement.classList.contains(CLS);
      document.documentElement.classList.toggle(CLS, on);
      try {
        if (on) { window.localStorage.setItem(KEY, '1'); } else { window.localStorage.removeItem(KEY); }
      } catch (e) {}
      sync();
    });
  });

  sync();
})();
